<template>
<div class="chapter">
<div class="inner_page">
<h1 class="partno"><a id="page_1"><em class="italic">PART I</em></a></h1><a id="page_1">
<h1 class="parttitle"><em class="italic">Myth Is the Language of Historical Memory</em></h1>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Part01.vue?03ff0b2c